import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { UserProvider, useUser } from './ReportHooks';
import { initReactI18next } from 'react-i18next';
import { addCommas } from '@arema/components/Util';
import i18n from 'i18next';
import Locale from "@arema/components/src/locale";

import './style/reports.scss';
import 'fomantic-ui-css/semantic.css';
import 'frontier-css/css/frontier.css';

import API from './ReportsAPI';
import RouterComponent from './ReportsRouter';
import moment from 'moment';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

i18n.use(initReactI18next).use(Locale('reports')).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

i18n.services.formatter.addCached('commas', (lng, options: { fixed: boolean, hideZero: boolean })=>{
	return val=>{
		return addCommas(val, options.fixed===true, options.hideZero===true);
	}
})

var Root = () => {
	var { login: is_login, user } = useUser();
	var is_auth = !user && window.location.pathname === '/auth';

	useEffect(() => {
		var now = moment().unix();
		var login = API.getToken();
		if ((!login || now > (login.expires - 30)) && !is_auth) {
			window.location.href = API.getAuthUrl();
		}

		var logoutEvent = () => {
			if (!is_login) {
				window.location.href = API.getAuthUrl();
			}
		}
		window.addEventListener('user_external_logout', logoutEvent);
		return () => {
			window.removeEventListener('user_external_logout', logoutEvent);
		}
	}, [is_login]);

	var RouterNav = RouterComponent();

	return <UserProvider>
		<RouterProvider router={RouterNav} />
	</UserProvider>
}

root.render(<Root />);